// Единый источник правды для версии билда
export const getClientBuildVersion = (): string => {
  const fallbackSource = import.meta.env.NEXT_PUBLIC_BUILD_SHA_SOURCE?.trim();
  const isTimeFallback = fallbackSource === 'time';

  const resolveTimeFallback = () => {
    const time = import.meta.env.NEXT_PUBLIC_BUILD_TIME?.trim();
    if (time) {
      // Convert 2025-09-20T16:12:56.059Z -> 20250920T161 for consistency with error message
      return time.replace(/[:.Z-]/g, '').replace('T', 'T').substring(0, 11);
    }
    return 'dev';
  };

  if (isTimeFallback) {
    return resolveTimeFallback();
  }

  // PRIORITY 1: Use direct __BUILD_SHA__ injection which is guaranteed by vite.config.ts
  try {
    // Access __BUILD_SHA__ directly without typeof check - Vite define should replace this
    const buildSha = __BUILD_SHA__;
    if (buildSha && buildSha !== 'dev' && buildSha.length >= 6) {
      return buildSha;
    }
  } catch {
    /* __BUILD_SHA__ not available, continue to next priority */
  }

  // PRIORITY 2: Use NEXT_PUBLIC_ACTUAL_BUILD_SHA which is injected by vite.config.ts
  const actualSha = import.meta.env.NEXT_PUBLIC_ACTUAL_BUILD_SHA?.trim();
  if (actualSha && actualSha !== 'dev' && actualSha.length >= 6) {
    return actualSha;
  }

  // PRIORITY 3: Fallback to original NEXT_PUBLIC_BUILD_SHA (from environment)
  const sha = import.meta.env.NEXT_PUBLIC_BUILD_SHA?.trim();
  if (sha && sha !== 'dev' && sha.length >= 6 && /^[a-f0-9]+$/i.test(sha)) {
    return sha;
  }

  return resolveTimeFallback();
};

export const isProdRuntime =
  import.meta.env.NEXT_PUBLIC_ENV_LABEL === 'PRD' &&
  import.meta.env.NEXT_PUBLIC_RUNTIME_ENV === 'prod';